import { ReactNode } from "react";
import { AppShell } from "@/components/layout/AppShell";

/** Routes authentifiées / app — header + bannière + sidebar + contenu */
export const AuthenticatedLayout = ({ children }: { children: ReactNode }) => (
  <AppShell showSidebar>{children}</AppShell>
);

/** Routes publiques sans sidebar — header + bannière + contenu centré */
export const PublicLayout = ({ children }: { children: ReactNode }) => (
  <AppShell showSidebar={false}>{children}</AppShell>
);
